// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2I6S-","large":"styles_large__2FhQZ"};